export default __webpack_public_path__ + "static/media/haeuser_intro_web-xs@1x.37ec950d.webp";